@if (specifications.error()) {
  <ideal-error [error]="specifications.error()"></ideal-error>
} @else {
  <div class="specifications">
    @for (specification of specificationItems(); track $index; let isFirst = $first; let isLast = $last) {
      <div class="label" [class.first]="isFirst" [class.last]="isLast">{{ specification.label }}</div>
      <div class="values" [class.first]="isFirst" [class.last]="isLast">
        @for (attr of specification.values; track $index) {
          <div class="value">{{ attr.value }}</div>
        }
      </div>
    }
  </div>
}
